export class BaseContainer {
  constructor() {
    /** @type {Object} Singleton instance for authentication service */
    this.authenticationService = null;
    /** @type {Object} Singleton instance for active directory service */
    this.activeDirectoryService = null;
    /** @type {Object} Redux store instance */
    this.store = null;
    /** @type {Object} Singleton instance for redux store persistor */
    this.persistor = null;
    /** @type {Object} Browser history instance */
    this.history = null;
    this.config = null;
    /** @type {Object} Singleton instance for cookies service */
    this.cookiesService = null;
  }

  getConfig() {
    return this.config;
  }

  setConfig(config) {
    this.config = config;
  }

  setService(service) {
    this.authenticationService = service;
  }

  setCookiesService(service) {
    this.cookiesService = service;
  }

  setActiveDirectoryService(service) {
    this.activeDirectoryService = service;
  }

  setPersistor(persistor) {
    this.persistor = persistor;
  }

  setStore(store) {
    this.store = store;
  }

  setHistory(history) {
    this.history = history;
  }

  getHistory() {
    return this.history;
  }

  getStoreState() {
    return this.store.getState();
  }
}
